module.exports = __webpack_public_path__ + "static/media/lifesaver.55ea373b.JPG";